exports.deployStatus = {
    wait: {
        val: 'pending'
    },
    progressing: {
        val: 'progressing'
    },
    failed: {
        val: 'failed'
    },
    success: {
        val: 'success'
    },
    done: {
        val: 'done' // for h3, deploy done, maybe some success,some failed.
    },
    rollback: {
        val: 'rollback'
    },
    rolldone: {
        val: 'rolldone'
    },
    timeout: {
        val: 'timeout'
    }
};
exports.status = {
    b_user: {
        valid: {
            explain: '有效',
            val: 0
        },
        invalid: {
            explain: '注销',
            val: 1
        },
    },
};

exports.logoutType = {
    updateUserRoleInfo: {
        val: 'updateUserRoleInfo',
        explain: '当前用户/角色等信息更新'
    },
    deleteUser: {
        val: 'deleteUser',
        explain: '当前用户被删除'
    },
    loginAgain: {
        val: 'loginAgain',
        explain: '当前用户在其他地方登录'
    }
};

exports.specType = {
    ST: {
        val: 'ST',
        explain: '抽检',
    },
    AURT: {
        val: 'AURT',
        explain: '自动复测' // 用于芯片记录
    },
    STOP: {
        val: 'STOP',
        explain: '停测'
    },
    REVERSESTOP: {
        val: 'REVERSESTOP',
        explain: '反向停测',
        specKey: 'reverseStopSpec'
    },
    FAILSTOP: {
        val: 'FAILSTOP',
        explain: 'OS失效停测',
        specKey: 'failStopSpec'
    }
};

const testType = {
    FT: {
        val: 'FT',
        explain: '测试',
    },
    OT: {
        val: 'OT',
        explain: '点检',
    },
    RT: {
        val: 'RT',
        explain: '复测',
    },
    ST: {
        val: 'ST',
        explain: '自动抽检',
    },
    QC: {
        val: 'QC',
        explain: '质检',
    },
    DBG: {
        val: 'DBG',
        explain: '调试',
    },
    AURT: {
        val: 'AURT', // 只出现在FT或RT中，无单独此选项；
        replaceVal: ['FT', 'RT'],
        explain: '自动复测' // 用于芯片记录
    },
    SV: {
        val: 'SV', //sample verification
        explain: '复合点检'
    }
};

exports.testType = testType;

let workType = {
    SERIES: {
        explain: '连续',
        val: 'SERIES'
    },
    SINGLE: {
        explain: '单次',
        val: 'SINGLE'
    }
};

exports.testerStartParams = workType;

exports.TestProjectSetting = {
    testType: testType,
    status: {
        wait: {
            val: 'wait',
            explain: '等待审核'
        },
        pass: {
            val: 'pass',
            explain: '通过'
        },
        failed: {
            val: 'failed',
            explain: '不通过'
        }
    },
    valid: {
        save: {
            val: 'save',
            explain: '保存'
        },
        publish: {
            val: 'publish',
            explain: '发布'
        },
        deleted: {
            val: 'deleted',
            explain: '已删除',
        },
    }
};

exports.kbValue = {
    status: {
        wait: {
            val: 'wait',
            explain: '等待'
        },
        save: {
            val: 'save',
            explain: '保存'
        },
        publish: {
            val: 'publish',
            explain: '发布'
        },
        deleted: {
            val: 'deleted',
            explain: '已删除',
        },
    }
};

exports.packageNo = [{
    name: 'SSOP-24-225-0.635'
}, {
    name: 'CPC-24-DG-FRL'
}, {
    name: 'SOP-16-225-1.27'
}];

exports.TestOrders = {
    optionalDesc: {
        prodNo: {
            explain: '产品名称',
            val: ['LS9926']
        },
        chipName: {
            explain: '芯片名称',
            val: ['LSA7501B']
        },
        packageType: {
            explain: '封装形式',
            val: ['SSOP24']
        }
    },
    status: {
        pending: {
            val: 'pending',
            explain: '待测试'
        },
        testing: {
            val: 'testing',
            explain: '测试中',
        },
        rt: {
            val: 'retesting',
            explain: '复测'
        },
        end: {
            val: 'end',
            explain: '结批',
        },
        qc: {
            val: 'qc',
            explain: '质检中',
        },
        done: {
            val: 'done',
            explain: '批次测试完成'
        },
        abnormal: {
            val: 'abnormal',
            explain: '异常'
        },
        afterEnd: {
            val: ['end', 'qc', 'done'],
            explain: '已进行结批'
        },
        beforeEnd: {
            val: ['pending', 'testing', 'retesting'],
            explain: '测试中'
        }
    },
    valid: {
        valid: {
            val: 'valid',
            explain: '有效'
        },
        invalid: {
            val: 'invalid',
            explain: '无效'
        }
    },
    maxBatchCount: 1000000000,
};

exports.validDesc = {
    valid: {
        val: 'valid',
        explain: '有效'
    },
    invalid: {
        val: 'invalid',
        explain: '无效'
    }
};

exports.TestRecords = {
    testType: testType,
    workType: workType,
    status: {
        pending: {
            val: 'pending',
            explain: '等待'
        },
        start: {
            val: 'start',
            explain: '启动'
        },
        stop: {
            val: 'stop',
            explain: '暂停'
        },
        finished: {
            val: 'finished',
            explain: '完成',
        },
        online: {
            val: 'online', //不在数据库内使用
            explain: '在线',
        },
        offline: {
            val: 'offline', //不在数据库内使用
            explain: '离线',
        },
        abnormal: {
            val: 'abnormal', //不在数据库内使用
            explain: '异常'
        },
        toStart: {
            val: ['pending', 'stop'],
            explain: '可开始'
        },
        toStop: {
            val: ['start'],
            explain: '可暂停'
        },
    }
};

exports.TesterCmds = {
    status: {
        pending: {
            val: 'pending',
            explain: '等待'
        },
        done: {
            val: 'done',
            explain: '执行成功'
        }
    }
};

exports.testerReportType = {
    CHIPREC: {
        val: 'CHIPREC',
        explain: '测试记录'
    },
    INIT: {
        val: 'INIT',
        explain: '测试机开机主动上报'
    },
    UPGRADE: {
        val: 'UPGRADE',
        explain: '测试机固件更新进展'
    },
    UPGRADEDONE: {
        val: 'UPGRADEDONE',
        explain: '固件升级完成'
    },
    HEARTBEAT: {
        val: 'HEARTBEAT',
        explain: '心跳'
    }
};

exports.adjType = {
    exposureTime: {
        val: 'EXPOSURE',
        explain: '曝光时间'
    }
};

exports.testerCmd = {
    CONNECT: {
        cmd: 'CONNECT',
        explain: '建立连接',
        val: 0
    },
    START: {
        cmd: 'START',
        explain: '启动',
        val: 1
    },
    STOP: {
        cmd: 'STOP',
        explain: '停止',
        val: 2
    },
    CONFIGURE: {
        cmd: 'CONFIGURE',
        explain: '测试参数配置',
        val: 3
    },
    REFRESH: {
        cmd: 'REFRESH',
        explain: '强制用户刷新页面',
        val: 4
    },
    REPORT: {
        cmd: 'REPORT',
        explain: '获得测试数据',
        val: 9
    },
    ACK: {
        cmd: 'ACK',
        explain: '命令ACK',
        val: 10
    },
    INIT: {
        cmd: 'INIT',
        explain: '设备重启',
        val: 11
    },
    UPGRADE: {
        cmd: 'UPGRADE',
        explain: '升级固件',
        val: 12
    },
    CANCELUPGRADE: {
        cmd: 'CANCELUPGRADE',
        explain: '取消升级',
        val: 13
    },
    HEARTBEAT: {
        cmd: 'HEARTBEAT',
        explain: '心跳',
        val: 20
    },
    LOGOUT: {
        cmd: 'LOGOUT',
        explain: '登出',
        val: 21
    },
    ERROR: {
        cmd: 'ERROR',
        explain: '错误通知',
        val: 22
    },
};

exports.testerCmdErrorType = {
    rt: {
        val: 'rt',
        explain: '复检监控报警'
    },
    site: {
        val: 'site',
        explain: 'site异常报警'
    }
};

exports.testerCmdAck = {
    SUCCESS: {
        explain: '成功',
        val: 0
    },
    INVALIDDEV: {
        explain: '无效设备名',
        val: 1
    },
    PARAMESERR: {
        explain: '参数错误',
        val: 2
    },
    COMMERR: {
        explain: '通信错误',
        val: 3
    },
};

exports.AURTSpec = {
    type: 'AURT',
    mode: {
        realtime: {
            val: 'realtime',
            explain: '实时更新yield'
        },
        periodic: {
            val: 'periodic',
            explain: '定期更新yield'
        },
        all: {
            val: ['realtime', 'periodic']
        }
    },
    defaultInterval: 1000,
    // dTracing:  动态跟踪yield
};

exports.testerParams = {
    osData: [{
        lowerLimit: -0.9,
        upperLimit: -0.2
    }],
    rinData: [{
        lowerLimit: -20,
        upperLimit: -13
    }, {
        lowerLimit: 16,
        upperLimit: 22.5
    }, {
        lowerLimit: 16,
        upperLimit: 22.5
    }, {
        lowerLimit: 20,
        upperLimit: 27
    }],
    sdoData: [{
        lowerLimit: 2.8,
        upperLimit: 3.3
    }, {
        lowerLimit: 0,
        upperLimit: 0.4
    }],
    vrefData: [{
        lowerLimit: 1.19,
        upperLimit: 1.242
    }],
    funData: [{
        lowerLimit: 5.2,
        upperLimit: 6.3
    }],
    id8k9Data: [{
        lowerLimit: 4.6,
        upperLimit: 5.3
    }, {
        lowerLimit: 4.82,
        upperLimit: 5.11
    }, {
        lowerLimit: 0.03,
        upperLimit: 0.03
    }],
    id8k8Data: [{
        lowerLimit: 4.125,
        upperLimit: 4.5375
    }, {
        lowerLimit: 4.2025,
        upperLimit: 4.4625
    }, {
        lowerLimit: 0.03,
        upperLimit: 0.03
    }],
    id8k7Data: [{
        lowerLimit: 0.51,
        upperLimit: 0.58
    }, {
        lowerLimit: 0.525,
        upperLimit: 0.561
    }, {
        lowerLimit: 0.05,
        upperLimit: 0.05
    }],
    id8k2Data: [{
        lowerLimit: 9.4,
        upperLimit: 10.65
    }, {
        lowerLimit: 9.68,
        upperLimit: 10.275
    }, {
        lowerLimit: 0.03,
        upperLimit: 0.03
    }],
};

exports.deviceStatus = {
    offline: {
        explain: '离线',
        val: 0
    },
    online: {
        explain: '在线',
        val: 1
    },
};

exports.deviceErrCode = [{
    err: 'normal',
    explain: '正常',
    val: 0
}, {
    err: 'xx',
    explain: 'xx',
    val: 1
}];

exports.error = {
    Err101: {
        val: 101,
        explain: '抽检不合格',
        monitor_target_name: 'st',
    },
    Err102: {
        val: 102,
        explain: '电路反向失效',
        monitor_target_name: 'reverseDirectionError',
    },
    Err201: {
        val: 201,
        explain: '合格率低于停机合格率',
    },
    Err202: {
        val: 202,
        explain: 'site之间失效分布异常',
    },
    Err301: {
        val: 301,
        explain: 'site间成品率差异异常',
    },
    Err302: {
        val: 302,
        explain: '成品率异常',
    },
    Err401: {
        val: 401,
        explain: '产量异常',
    },
    Err999: {
        val: 999,
        explain: '用户自定义错误',
    }
};

exports.errorLevel = {
    info: {
        val: 'info',
        explain: '信息',
    },
    warn: {
        val: 'warn',
        explain: '警告',
    },
    error: {
        val: 'error',
        explain: '错误',
    },
    fatal: {
        val: 'fatal',
        explain: '严重错误',
    },
};

exports.errorRecordStatus = {
    waiting: {
        val: 'waiting',
        explain: '待处理',
    },
    noticed: {
        //暂时不使用
        val: 'noticed',
        explain: '已通知',
    },
    done: {
        val: 'done',
        explain: '已处理',
    },
    Wontdo: {
        val: 'Wontdo',
        explain: '无法处理',
    }
};


exports.errorHanding = {
    notice: {
        explain: 'web提示',
        params: null,
        name: 'notice',
    },
    email: {
        explain: '邮件提示',
        params: 'email',
        name: 'email',
    },
    sms: {
        explain: '短信提示',
        params: 'phone',
        name: 'sms',
    },
    // dingding: {
    //     explain: '钉钉提示',
    //     params: 'email',
    //     name: 'dingding',
    // },
    // weChat: {
    //     explain: '微信提示',
    //     params: null,
    //     name: 'weChat',
    // },
    devStop: {
        explain: '测试机停机',
        params: null,
        name: 'devStop',
    },
};

exports.targetTypes = {
    yieldDiff: {
        val: 'yieldDiff',
        explain: '成品率差异',
        word: '成品率',
        error_code: 301,
    },
    output: {
        val: 'output',
        explain: '产量',
        word: '产量',
        error_code: 401,
    },
    st: {
        val: 'st',
        explain: '抽检',
        word: '抽检',
        error_code: 101,
    },
};

exports.ruleTypes = {
    realtime: {
        val: 'realtime',
        explain: '实时'
    },
    cron: {
        val: 'cron',
        explain: '定时'
    },
    date: {
        val: 'date',
        explain: '指定日期'
    },
    error: {
        val: 'error',
        explain: '错误通知上报'
    },
};

exports.alertRule = {
    gt: {
        explain: '大于',
    },
    gte: {
        explain: '大于等于',
    },
    lt: {
        explain: '小于',
    },
    lte: {
        explain: '小于等于',
    },
    eq: {
        explain: '等于',
    },
    neq: {
        explain: '不等于',
    },
};

exports.default_errorHanding = {
    notice: {
        explain: 'web提示',
        params: null,
    },
    weChat: {
        explain: '微信提示',
        params: null
    },
};

exports.erp_errcode = {
    refused: '连接被拒绝',
    incoOrderErr: '来料信息不存在',
};

var smsTemplateCode = {
    error_notify: 'SMS_168820868',
};

exports.smsTemplateCode = smsTemplateCode;

exports.confOperation = {
    create: {
        val: 'create',
        explain: '创建'
    },
    update: {
        val: 'update',
        explain: '更改'
    },
    remove: {
        val: 'remove',
        explain: '用户删除'
    },
    delete: {
        val: 'delete',
        explain: '删除'
    },
    recovery: {
        val: 'recovery',
        explain: '恢复标记环境'
    },
    restore: {
        val: 'restore',
        explain: '从回收站恢复'
    }

};
